import { env } from '@/utils'

import { TranslationMappingStyleEnum } from './generalConstants'

export const API_ROUTES = {
	billing: {
		paymentDetails: '/clients/billing/payment-details',
		transactions: '/clients/billing/transactions',
		invoice: (transactionId: string) =>
			`/clients/billing/transactions/${transactionId}/invoice`,
	},
	mediaStorage: {
		uploadConfig: '/common/media/r2-signature',
		reportUpload: '/common/media/front-upload-complete-r2',
	},
	user: {
		nativeLanguages: '/clients/user-settings/native-languages',
	},
	subscription: {
		products: '/common/products',
		currencies: '/common/products/currencies',
		request: '/common/subscriptions/cancel-request',
		userProducts: '/clients/products',
		current: '/clients/subscriptions',
		checkoutMetadata: '/clients/checkout-metadata',
		createStripe: '/clients/subscriptions/stripe',
		createPayPal: '/clients/subscriptions/paypal',
		createPayPalInitial: '/clients/subscriptions/paypal/initial',
		cancel: (subscriptionId: string) =>
			`/clients/subscriptions/cancel/${subscriptionId}`,
		reactivate: (subscriptionId: string) =>
			`/clients/subscriptions/reactivate/${subscriptionId}`,
		common: {
			cancelRequest: '/common/subscriptions/cancel-request',
			cancel: (subscriptionId: string) =>
				`/common/subscriptions/cancel/${subscriptionId}`,
		},
	},
	translations: (locale: string, isServer: boolean = false) =>
		`${isServer ? (env.INTERNAL_API_URL ?? env.API_URL) : env.API_URL}/common/translations/${locale}?mode=${TranslationMappingStyleEnum.UNDERSCORE_NOTATION}` as const,
	qrCodeScansStats: (isServer: boolean = false) =>
		`${isServer ? (env.INTERNAL_API_URL ?? env.API_URL) : env.API_URL}/common/qr-codes/scans-stats` as const,
	userSettings: {
		bannerClicked: '/clients/user-settings/banner',
		changeEmail: '/clients/user-settings/change-email',
		changeLanguage: '/clients/user-settings/change-language',
		changePassword: '/clients/user-settings/change-password',
		changeTimezone: '/clients/user-settings/change-timezone',
		companyInfo: '/clients/user-settings/company-info',
		firstLoginMarketing: '/clients/user-settings/first-login-marketing',
		generalInfo: '/clients/user-settings/general-info',
		getCountries: '/clients/user-settings/countries',
		getLanguages: '/clients/user-settings/languages',
		getNativeLanguages: '/clients/user-settings/native-languages',
		getTimeZone: '/clients/user-settings/timezones',
		getSettingsInfo: '/clients/user-settings',
		getUser: '/clients/user-settings/get-user',
		enable2Fa: '/clients/user-settings/2fa/enable',
	},
	auth: {
		login: '/auth/login',
		loginAsUser: (userId: string) => `/admins/users/${userId}/login`,
		signUp: '/auth/signup',
		onboardingSignUp: '/auth/onboarding-signup',
		forgotPassword: '/auth/forgot-password',
		refreshToken: '/auth/refresh',
		validateAutologinToken: '/auth/token/validate',
		refreshTokenServer: '/auth/refresh/server',
		resetPassword: '/auth/reset-password',
		resetPasswordCheck: '/auth/reset-password-check',
		googleLogin: '/auth/google-login',
		googleSignUp: '/auth/google-signup',
		facebookLogin: '/auth/facebook-login',
		facebookSignUp: '/auth/facebook-signup',
		appleLogin: '/auth/apple-login',
		appleSignUp: '/auth/apple-signup',
		logout: '/auth/logout',
		delete: '/auth/delete-account',
		// 2FA
		activate2fa: '/auth/2fa-qr-code',
		verify2fa: '/auth/verify2fa',
		disable2fa: 'clients/user-settings/2fa/disable',
	},
	qrCode: {
		base: '/qr-codes',
		deactivate: '/qr-codes/deactivate',
		activate: '/qr-codes/activate',
		resetScans: '/qr-codes/reset-scans',
		duplicate: '/qr-codes/duplicate',
	},
	analytics: {
		batch: '/clients/analytics/v2/batch',
		filtersQrCode: '/clients/analytics/filters/qr-code',
		filtersOs: '/clients/analytics/filters/os',
		filtersCountries: '/clients/analytics/filters/countries',
		filtersCities: '/clients/analytics/filters/cities',
		filtersBatch: '/clients/analytics/filters/batch',
		export: '/clients/analytics/export',
	},
	support: {
		contactUs: '/support/contact-us',
	},
} as const
